import React from 'react';
import { Button } from '@fluentui/react-components';
import { useSuggestedPromptsMenuStyles } from './SuggestedPromptsMenu';

interface SuggestedPromptsRootViewProps {
    onSaveNewPrompt: () => void;
    onShowYourPrompts: () => void;
    onShowPromptSuggestions: () => void;
}

const SuggestedPromptsRootView: React.FC<SuggestedPromptsRootViewProps> = ({
    onSaveNewPrompt,
    onShowYourPrompts,
    onShowPromptSuggestions,
}) => {
    const styles = useSuggestedPromptsMenuStyles();

    return (
        <>
            <div className={styles.saveButtonContainer}>
                <Button appearance="transparent" className={styles.saveButton} onClick={onSaveNewPrompt}>
                    Save New Prompt
                </Button>
            </div>
            <div className={styles.section}>
                <Button appearance="transparent" className={styles.sectionHeaderButton} onClick={onShowYourPrompts}>
                    <span className={styles.sectionHeaderText}>Your Prompts</span>
                </Button>
            </div>
            <div className={styles.section}>
                <Button
                    appearance="transparent"
                    className={styles.sectionHeaderButton}
                    onClick={onShowPromptSuggestions}
                >
                    <span className={styles.sectionHeaderText}>Prompt Suggestions</span>
                </Button>
            </div>
        </>
    );
};

export default SuggestedPromptsRootView;
